module.exports = __webpack_public_path__ + "img/project14_2.b9282dcb.jpg";